<div *ngIf="loader" id="spinerLoader" class="container">
    <ds-loading-spinner [diameter]="100" [strokeWidth]="11" color="#b52323"></ds-loading-spinner>
</div>

<div mat-dialog-title class="modal-header header-radius-4 py-0 mb-2">
    <div class="mx-3 d-flex justify-content-between align-items-center">
        <div>
            <h4>Split Record</h4>
        </div>
        <div>
            <button mat-dialog-close class="close close-btn" type="button">
                <ds-icon name="close" size="inherit"></ds-icon>
            </button>
        </div>
    </div>
</div>
<mat-dialog-content class="mb-0">
    <div class="member-card mb-0">
        <div class="row">
            <div *ngFor="let defaultRecord of splitRecordDefaultFields" class="col-lg-3 col-md-4 col-sm-6 col-xs-12">
                <div class="form-group">
                    <label>{{ defaultRecord.fieldDisplayName }}</label>
                    <input [id]="defaultRecord.id" class="form-control" disabled type="text" [value]="defaultRecord.value" />
                </div>
            </div>
        </div>
    </div>
    <div class="member-card mb-0 mt-4">
        <h4>Split the Record</h4>
        <div class="row mx-0">
            <div class="tableSpacing">
                <div class="box-body table-responsive-sm|table-responsive-md|table-responsive-lg px-0 py-0">
                    <table id="split_record_table" class="table card-layout table-striped table mt-0">
                        <thead>
                            <tr id="main_row_headingId_split_record">
                                <td class="header_td table_heading">
                                    <div class="header_container text-primary">
                                        <div *ngFor="let column of splitRecordTableColumns" class="header_title header-color cursorPointer">
                                            {{ column }}
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </thead>
                        <table class="my-0">
                            <tr *ngIf="isShowSplitRecordTableSpinnerLoader">
                                <div class="row my-4">
                                    <div class="d-flex justify-content-center">
                                        <ds-loading-dots size="lg" color="#a82b41" class="mY-25-50"></ds-loading-dots>
                                    </div>
                                </div>
                            </tr>
                            <tr *ngFor="let record of splittedBlockTimeRecordList; let record_index = index">
                                <td>
                                    <div id="split_record_main_row_{{ record_index }}" class="row_container px-2 py-2">
                                        <div class="title_container">
                                            <div class="row_title">Direction</div>
                                            <div class="row_detail">
                                                {{ record.direction }}
                                            </div>
                                        </div>
                                        <div class="title_container">
                                            <div class="row_title">Origin</div>
                                            <div class="row_detail cursorPointer">
                                                {{ record.origin != null ? record.origin : 'NA' }}
                                            </div>
                                        </div>
                                        <div class="title_container">
                                            <div class="row_title">Destination</div>
                                            <div class="row_detail">
                                                {{ record.destination != null ? record.destination : 'NA' }}
                                            </div>
                                        </div>
                                        <div class="title_container">
                                            <div class="row_title">Driver</div>
                                            <div class="row_detail">
                                                <div>{{ record.driverName }}</div>
                                                <div>{{ record.phoneNumber | phoneNumberPipe }}</div>
                                            </div>
                                        </div>
                                        <div class="title_container">
                                            <div class="row_title">Customer</div>
                                            <div class="row_detail my-2 mx-3">
                                                <div class="select-box">
                                                    <ng-multiselect-dropdown-angular7
                                                        [settings]="customerListDropdownSetting"
                                                        [data]="dialogData.customerList"
                                                        [placeholder]="'Customer'"
                                                        [(ngModel)]="record.customer"
                                                        (onDeSelect)="isRecordsValidToSplit()"
                                                        (onSelect)="isRecordsValidToSplit()"
                                                    >
                                                    </ng-multiselect-dropdown-angular7>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </table>
                    </table>
                </div>
            </div>
        </div>
    </div>
</mat-dialog-content>
<mat-dialog-actions class="mb-0 d-flex justify-content-center">
    <button mat-dialog-close class="flat-butt flat-info-butt flat-info-grad-butt close-btn mr-4" title="Split the record..." type="button">
        Cancel
    </button>
    <button
        class="flat-butt flat-info-butt flat-info-grad-butt save-btn"
        title="Split the record..."
        type="button"
        [ngClass]="{ notAllowedPointer: !splitRecordDialogService.isValidToSplit }"
        (click)="splitBlockTimeRecord()"
    >
        Save Changes
    </button>
</mat-dialog-actions>
